module.exports = __webpack_public_path__ + "static/media/Паспорт на Галеон серии L.c05448e8.pdf";